<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="order-main-sidebar" position="left" lockedOpen="gt-md">
        <language-main-sidebar></language-main-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)">

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">

                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Name' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.name}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Short name' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.shortName}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="true" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <a routerLink="/cms/languages/edit/{{row.id}}">{{'Edit'|translate}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>